import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "triang" }, null, -1)
const _hoisted_2 = { class: "count" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_ctx.filterData[_ctx.type].count)
    ? (_openBlock(), _createBlock("button", {
        key: 0,
        class: ["onetrip-page__filter__btn", { isActive: _ctx.isActive(_ctx.orderType) }],
        onClick: _cache[1] || (_cache[1] = $event => (_ctx.setActive(_ctx.orderType)))
      }, [
        _hoisted_1,
        _createTextVNode(" " + _toDisplayString(_ctx.title) + " ", 1 /* TEXT */),
        _createVNode("div", _hoisted_2, _toDisplayString(_ctx.filterData[_ctx.type].count), 1)
      ], 2))
    : _createCommentVNode("", true)
}